/** Opções espelhadas do dash legado (client_insert / client_edit). */

export const CLIENT_SECTOR_OPTIONS = [
  'Indústria',
  'Gastronomia',
  'Moda',
  'Supermercado',
  'Farmácia',
  'E-commerce',
  'Agencia de publicidade',
  'Beleza',
  'Acessórios',
  'Comércio',
  'Entretenimento',
  'Outros',
] as const;

export const CLIENT_PROFILE_OPTIONS = [
  'Franquia',
  'Mais de 5 diferentes pontos de venda',
  'Entre 2 e 5 diferentes pontos de venda',
  'Um ponto de venda',
  '100% online',
  'Marca',
] as const;

/**
 * Módulos reais oferecidos pela fixe. Preferir sempre o catálogo em
 * `/modulos` (API `/catalog/module`) — esta lista só serve de referência
 * histórica e não deve ser usada para renderizar opções de formulário.
 */
export const CLIENT_PRODUCT_OPTIONS = [
  'Fidelidade 360',
  'Campanha Automatizada',
  'Pesquisa',
  'Combo Módulos - Pacote 1',
  'Combo Módulos - Pacote 2',
  'Super APP',
  'Cartão Presente / Gift Card',
  'Cartão Pré Pago',
] as const;

export type ClientSector = (typeof CLIENT_SECTOR_OPTIONS)[number];
export type ClientProfile = (typeof CLIENT_PROFILE_OPTIONS)[number];
export type ClientProduct = (typeof CLIENT_PRODUCT_OPTIONS)[number];
